import React from 'react';
import { FiMapPin } from 'react-icons/fi';
import styles from './Experience.module.css';
import { useLanguage } from '../../context/LanguageContext';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

interface Job {
  company: string;
  role: string;
  period: string;
  location: string;
  current?: boolean;
}

const jobs: Job[] = [
  { company: '3DUniversum', role: 'Senior Full Stack Developer', period: 'Jul 2025 – Present', location: 'Amsterdam, Netherlands', current: true },
  { company: 'TOSS Group', role: 'Senior Full Stack Developer', period: 'Nov 2024 – Jul 2025', location: 'Amsterdam, Netherlands' },
  { company: 'PXON', role: 'Full Stack Developer', period: 'Jun 2022 – Nov 2024', location: 'Amsterdam, Netherlands' },
  { company: 'PXON', role: 'Software Developer', period: 'May 2020 – May 2022', location: 'İzmir, Turkey' },
  { company: 'Spotify', role: 'Frontend Developer', period: '2017 – 2021', location: 'Remote' },
  { company: 'Risus Tech', role: 'Game Developer', period: 'Oct 2019 – May 2020', location: 'İzmir, Turkey' },
  { company: 'Heal2Go BV', role: 'Full Stack Developer', period: 'Aug 2018 – Oct 2019', location: 'İzmir, Turkey' },
  { company: 'Çizgi Tagem', role: 'Educator', period: 'Jan 2014 – Dec 2018', location: 'Istanbul, Turkey' },
  { company: 'Ata Medya', role: 'Full Stack Developer', period: 'Jun 2013 – Aug 2018', location: 'Istanbul, Turkey' },
  { company: 'Ata Medya', role: 'Development Intern', period: 'Jun 2012 – Jun 2013', location: 'Istanbul, Turkey' },
];

const Experience: React.FC = () => {
  const { t } = useLanguage();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="experience" className="section">
      <div className="container">
        <div className={`section-header fade-in ${isVisible ? 'visible' : ''}`}>
          <span className="section-tag">{t.experience.subtitle}</span>
          <h2 className="section-title">{t.experience.title}</h2>
        </div>

        <div
          ref={ref as React.RefObject<HTMLDivElement>}
          className={`${styles.timeline} fade-in ${isVisible ? 'visible' : ''}`}
        >
          {jobs.map((job, i) => (
            <div key={i} className={`${styles.item} ${job.current ? styles.current : ''}`}>
              <div className={styles.line} />
              <div className={styles.dot} />
              <div className={styles.card}>
                <div className={styles.cardHeader}>
                  <h3 className={styles.company}>{job.company}</h3>
                  <span className={styles.period}>
                    {job.period.includes('Present') ? job.period.replace('Present', t.experience.present) : job.period}
                  </span>
                </div>
                <p className={styles.role}>{job.role}</p>
                <p className={styles.location}>
                  <FiMapPin size={12} /> {job.location}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
